
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b4c4f818&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StyleEditor.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./StyleEditor.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-b4c4f818!../../node_modules/vue-loader/lib/selector?type=template&index=0!./StyleEditor.vue"),
  /* scopeId */
  "data-v-b4c4f818",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/StyleEditor.vue
// module id = 44
// module chunks = 1